import type { AssistantConversation, ChatStatus } from "@rivets/core";

/**
 * Whether an assistant conversation is waiting for its owner's approval. The
 * live chat status wins once it is known — the socket patches it the moment
 * the conversation is approved, while the assistant state's flag only moves
 * on its next fetch — and the flag answers before the chat detail arrives.
 */
export function conversationAwaitingApproval(
  conversation: Pick<AssistantConversation, "awaitingApproval"> | undefined,
  chatStatus: ChatStatus | undefined,
): boolean {
  if (chatStatus) return chatStatus === "awaiting_approval";
  return conversation?.awaitingApproval === true;
}

/** The chat a `?assistant=<chatId>` link — the Slack "waiting for approval"
 * reply — asks the drawer to open, if the param is a plausible id. */
export function assistantDeepLinkChatId(search: Record<string, unknown>): string | undefined {
  const value = search.assistant;
  return typeof value === "string" && /^[A-Za-z0-9_-]{1,128}$/.test(value) ? value : undefined;
}

/** The same search without the consumed `assistant` param. */
export function withoutAssistantDeepLink<T extends Record<string, unknown>>(search: T): Omit<T, "assistant"> {
  const { assistant: _consumed, ...rest } = search;
  return rest;
}
